import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  MenuItem,
  Snackbar,
  Alert,
  CircularProgress,
  useMediaQuery,
  Modal,
  Autocomplete,
  AppBar,
  InputBase,
  Card,
  CardContent,
  Stack,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Tooltip,
  IconButton,
  TextField,
} from "@mui/material";
import DirectionsWalkOutlinedIcon from "@mui/icons-material/DirectionsWalkOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import LanguageIcon from "@mui/icons-material/Language";
import CircleIcon from "@mui/icons-material/Circle";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/system";
import Navbar from "../../../Navbar";
import Footer from "../../../Footer";
import Header from "../../../Header";
import Request from "./ActionComponent/Request";
import Handoversession from "./ActionComponent/Handoversession";
import { API_URL } from "../../Config/api";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  // border: '2px solid #000',
  pt: 2,
  px: 4,
  pb: 3,
};

const EnquiryCard = styled(Card)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: "10px",
  backgroundColor: "white",
  boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
  height: "50px",
  borderRadius: "10px",
  transition: "2s ease-in-out",
  "&:hover": {
    backgroundColor: "rgb(235, 229, 229)",
    cursor: "pointer",
    // boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.15)",
  },
});

const request = [
  { value: "default", label: "Select Request" },
  { value: "1", label: "Cancel" },
  { value: "2", label: "Reschedule" },
  { value: "3", label: "Case Handover" },
];

const requestby = [
  {
    value: "default",
    label: "Request by",
  },
  // {
  //     value: '1',
  //     label: 'Service',
  // },
  {
    value: "2",
    label: "Session",
  },
  {
    value: "3",
    label: "Attendence",
  },
];

const selectType = [
  {
    value: "default",
    label: "Select Type",
  },
  {
    value: "1",
    label: "Patient",
  },
  {
    value: "2",
    label: "Professional",
  },
];

const ProfRequest = () => {
  // const port = process.env.REACT_APP_API_KEY;
  const accessToken = localStorage.getItem("token");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [open, setOpen] = useState(false);
  const [openReject, setOpenReject] = useState(false);
  const [rejectReqID, setRejectReqID] = useState("");
  const [rejectRemark, setRejectRemark] = useState("");

  const [profRequest, setProfRequest] = useState([]);
  const [profReqID, setProfReqID] = useState([]);
  const [eveId, setEveId] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const [srvId, setSrvId] = useState(null);
  const [startDate, setStartDate] = useState("");
  const extractedDate = startDate ? startDate.split(" ")[0] : "";
  const [startTime, setStartTime] = useState("");
  const [endDate, setEndDate] = useState("");
  const [endTime, setEndTime] = useState("");
  const [mode, setMode] = useState("approve"); // "approve" or "reject"

  const [tableHeight, setTableHeight] = useState("auto");
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const [loading, setLoading] = useState(true);

  const [selectedRequestID, setSelectedRequestID] = useState("default");
  const [selectedRequestbyID, setSelectedRequestbyID] = useState("default");
  const [selectedType, setSelectedType] = useState("default");

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [openHandover, setOpenHandover] = useState(false);
  const [selectedHandoverData, setSelectedHandoverData] = useState(null);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  //Code for Model
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleOpenReject = () => setOpenReject(true);
  const handleCloseReject = () => setOpenReject(false);

  const handleOpenHandoverReject = (data) => {
    setSelectedHandoverData(data); // 🟢 store clicked record
    setOpenHandover(true);
  };

  //Cancel Reason change Logic
  const handleRequestChange = (event) => {
    setSelectedRequestID(event.target.value);
  };

  const handleRequestbyChange = (event) => {
    setSelectedRequestbyID(event.target.value);
  };

  const handleSelectedTypeChange = (event) => {
    setSelectedType(event.target.value);
  };

  useEffect(() => {
    const updateTableHeight = () => {
      const screenHeight = window.innerHeight;
      setTableHeight(`${screenHeight}px`);
    };
    updateTableHeight();
    window.addEventListener("resize", updateTableHeight);

    return () => {
      window.removeEventListener("resize", updateTableHeight);
    };
  }, []);

  // useEffect(() => {
  //     const getProfRequest = async () => {
  //         if (selectedRequestID && selectedRequestbyID) {
  //             try {
  //                 const res = await fetch(`${port}/web/get_reschedule_cancle_request/${selectedRequestID}/${selectedRequestbyID}/`, {
  //                     headers: {
  //                         'Authorization': `Bearer ${accessToken}`,
  //                         'Content-Type': 'application/json',
  //                     },
  //                 });
  //                 const data = await res.json();
  //                 console.log("Professional Request Data.......", data);
  //                 if (data.message === "Data not found.") {
  //                     setProfRequest([]);
  //                     setLoading(false);
  //                 } else {
  //                     setProfRequest(data);
  //                     setLoading(false);
  //                 }
  //             } catch (error) {
  //                 console.error("Error fetching Professional Request Data:", error);
  //                 setLoading(false);
  //             }
  //         }
  //     };
  //     getProfRequest();
  // }, [selectedRequestID, selectedRequestbyID]);

  const getProfRequest = async () => {
    if (selectedRequestID && selectedRequestbyID) {
      setLoading(true);
      try {
        let url = "";

        // ✅ Case Handover request (value 3)
        if (selectedRequestID === "3") {
          url = `${API_URL}/web/get_reschedule_cancle_request/3/`;
        } else {
          // ✅ Cancel / Reschedule request
          url = `${API_URL}/web/get_reschedule_cancle_request/${selectedRequestID}/${selectedRequestbyID}/`;
        }

        const res = await fetch(url, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        });

        const data = await res.json();
        console.log("Professional Request Data.......", data);

        if (data.message === "Data not found.") {
          setProfRequest([]);
        } else {
          setProfRequest(data);
        }
      } catch (error) {
        console.error("Error fetching Professional data:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    getProfRequest();
  }, [selectedRequestID, selectedRequestbyID]);

  function findPreFollowupRecords(eveId) {
    const matchingRecords = profRequest.find(
      (record) => record.eve_id === eveId,
    );
    console.log(matchingRecords, "kkkkkkkkkkkk");

    if (matchingRecords) {
      console.log("Prof request ID", matchingRecords.eve_id);
      setProfReqID(matchingRecords.eve_id);
      setEveId(matchingRecords.eve_id.eve_id);
      setSrvId(matchingRecords.epoc_id.srv_id?.srv_id);
      // setSessionId(matchingRecords.dtl_eve_id.agg_sp_dt_eve_poc_id)
      if (matchingRecords.dtl_eve_id !== null) {
        setSessionId(matchingRecords.dtl_eve_id.agg_sp_dt_eve_poc_id);
        setStartDate(matchingRecords.dtl_eve_id.actual_StartDate_Time);
        setEndDate(matchingRecords.dtl_eve_id.actual_EndDate_Time);
        setStartTime(matchingRecords.dtl_eve_id.start_time);
        setEndTime(matchingRecords.dtl_eve_id.end_time);
      } else {
        setSessionId(0);
        setStartDate("");
        setEndDate("");
        setStartTime("");
        setEndTime("");
      }
      if (matchingRecords.req_id !== null) {
        setRejectReqID(matchingRecords.req_id);
      } else {
        setRejectReqID(0);
      }
    }
  }

  async function handleRejectSubmit(event) {
    event.preventDefault();
    const requestData = {
      remark: rejectRemark,
    };
    console.log("POST API Hitting......", requestData);
    try {
      const response = await fetch(
        `${API_URL}/web/professional_request_rejection/${rejectReqID}/`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(requestData),
        },
      );
      if (!response.ok) {
        console.error(`HTTP error! Status: ${response.status}`);
        return;
      }
      const result = await response.json();
      console.log("Approve Rejection", result);
      setOpenSnackbar(true);
      setSnackbarMessage("Rejected successfully!");
      setSnackbarSeverity("success");
      handleCloseReject();
      // window.location.reload();
      getProfRequest();
    } catch (error) {
      console.error("An error occurred:", error);
    }
  }

  return (
    <>
      <Navbar />

      <Box sx={{ flexGrow: 1, mt: 13.6, ml: 1, mb: 2, mr: 1 }}>
        <Stack
          direction={isSmallScreen ? "column" : "row"}
          spacing={1}
          alignItems={isSmallScreen ? "center" : "flex-start"}
          sx={{ pt: 1 }}
        >
          <Typography
            style={{
              fontSize: 16,
              fontWeight: 600,
              marginTop: "10px",
              marginLeft: "10px",
            }}
            color="rgb(111, 117, 58)"
            gutterBottom
          >
            PROFESSIONAL REQUEST
          </Typography>

          {/* First Dropdown: always visible */}
          <Box
            component="form"
            sx={{
              marginLeft: "2rem",
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              width: 300,
              height: "2.5rem",
              backgroundColor: "#ffffff",
              boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
              borderRadius: "10px",
              border: "1px solid #C9C9C9",
            }}
          >
            <TextField
              id="request"
              name="request"
              select
              size="small"
              fullWidth
              value={selectedRequestID}
              onChange={handleRequestChange}
              sx={{
                textAlign: "left",
                "& input": { fontSize: "14px" },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { border: "none" },
                },
              }}
            >
              {request.map((option) => (
                <MenuItem
                  key={option.value}
                  value={option.value}
                  disabled={option.value === "default"}
                >
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>

          {/* Other dropdowns: hidden only if selectedRequestID === "3" */}
          {selectedRequestID !== "3" && (
            <>
              <Box
                component="form"
                sx={{
                  marginLeft: "2rem",
                  p: "2px 4px",
                  display: "flex",
                  alignItems: "center",
                  width: 300,
                  height: "2.5rem",
                  backgroundColor: "#ffffff",
                  boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
                  borderRadius: "10px",
                  border: "1px solid #C9C9C9",
                }}
              >
                <TextField
                  id="requestby"
                  name="requestby"
                  select
                  size="small"
                  fullWidth
                  value={selectedRequestbyID}
                  onChange={handleRequestbyChange}
                  sx={{
                    textAlign: "left",
                    "& input": { fontSize: "14px" },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": { border: "none" },
                    },
                  }}
                >
                  {requestby.map((option) => (
                    <MenuItem
                      key={option.value}
                      value={option.value}
                      disabled={option.value === "default"}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>

              <Box
                component="form"
                sx={{
                  marginLeft: "2rem",
                  p: "2px 4px",
                  display: "flex",
                  alignItems: "center",
                  width: 300,
                  height: "2.5rem",
                  backgroundColor: "#ffffff",
                  boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
                  borderRadius: "10px",
                  border: "1px solid #C9C9C9",
                }}
              >
                <TextField
                  id="selectType"
                  name="selectType"
                  select
                  size="small"
                  fullWidth
                  value={selectedType}
                  onChange={handleSelectedTypeChange}
                  sx={{
                    textAlign: "left",
                    "& input": { fontSize: "14px" },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": { border: "none" },
                    },
                  }}
                >
                  {selectType.map((option) => (
                    <MenuItem
                      key={option.value}
                      value={option.value}
                      disabled={option.value === "default"}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            </>
          )}
        </Stack>

        <TableContainer
          sx={{
            height:
              profRequest.length === 0 || profRequest.length < 5
                ? "60vh"
                : "default",
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <EnquiryCard
                  style={{
                    background: "rgb(240, 244, 204)",
                    color: "#000000",
                    borderRadius: "8px 10px 0 0",
                  }}
                >
                  <CardContent
                    style={{ flex: 0.3, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Sr. No</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 0.8, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Event Code</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 1, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">
                      Professional Name
                    </Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 1, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">
                      Professional Contact
                    </Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 1, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Service Name</Typography>
                  </CardContent>

                  {/* Session ID column */}
                  {selectedRequestbyID !== "1" && selectedRequestID !== "3" && (
                    <CardContent
                      style={{ flex: 0.5, borderRight: "1px solid #FFFFFF" }}
                    >
                      <Typography variant="subtitle2">Session ID</Typography>
                    </CardContent>
                  )}

                  {/* Session Date column */}
                  {selectedRequestbyID !== "1" && (
                    <CardContent
                      style={{ flex: 1, borderRight: "1px solid #FFFFFF" }}
                    >
                      <Typography variant="subtitle2">Session Date</Typography>
                    </CardContent>
                  )}

                  <CardContent style={{ flex: 1 }}>
                    <Typography variant="subtitle2">Action</Typography>
                  </CardContent>
                </EnquiryCard>
              </TableRow>
            </TableHead>
            {loading ? (
              <Box sx={{ display: "flex", mt: 20, ml: 80, height: "130px" }}>
                <CircularProgress />
              </Box>
            ) : (
              <TableBody>
                {profRequest.length === 0 ? (
                  <TableRow>
                    <CardContent>
                      <Typography variant="body2">No Data Available</Typography>
                    </CardContent>
                  </TableRow>
                ) : (
                  profRequest
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        key={row.eve_id}
                        value={row.eve_id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <EnquiryCard
                          sx={{
                            background: "#f1f1f1",
                            borderLeft: "4px solid transparent",
                            transition: "all 0.3s ease-in-out",
                            cursor: "pointer",
                            "&:hover": {
                              borderLeft: "4px solid rgb(136 151 2)",
                              borderRight: "4px solid rgb(136 151 2)",
                              transform: "scale(1)",
                            },
                          }}
                          // sx={{ bgcolor: "#f1f1f1" }}
                        >
                          <CardContent style={{ flex: 0.3 }}>
                            <Typography variant="body2">
                              {index + 1 + page * rowsPerPage}
                            </Typography>
                          </CardContent>
                          <CardContent style={{ flex: 0.8 }}>
                            <Typography variant="body2">
                              {row.eve_id.event_code}
                            </Typography>
                          </CardContent>
                          <CardContent style={{ flex: 1 }}>
                            {/* <Typography variant="body2">
                                                            {row.dtl_eve_id ? row.dtl_eve_id?.srv_prof_id?.prof_fullname : "-"}
                                                        </Typography> */}
                            {selectedRequestbyID === "1" ? (
                              <Typography variant="body2">
                                {row.prof_name ? row.prof_name : "-"}
                              </Typography>
                            ) : (
                              <Typography variant="body2">
                                {row.dtl_eve_id
                                  ? row.dtl_eve_id?.srv_prof_id?.prof_fullname
                                  : "-"}
                              </Typography>
                            )}
                          </CardContent>
                          <CardContent style={{ flex: 1 }}>
                            {/* <Typography variant="body2">
                                                            +91 {row.dtl_eve_id ? row.dtl_eve_id?.srv_prof_id?.phone_no : "-"}
                                                        </Typography> */}

                            {selectedRequestbyID === "1" ? (
                              <Typography variant="body2" textAlign="left">
                                +91 {row.prof_no ? row.prof_no : "-"}
                              </Typography>
                            ) : (
                              <Typography variant="body2">
                                +91{" "}
                                {row.dtl_eve_id
                                  ? row.dtl_eve_id?.srv_prof_id?.phone_no
                                  : "-"}
                              </Typography>
                            )}
                          </CardContent>
                          <CardContent style={{ flex: 1 }}>
                            <Typography variant="body2">
                              {row.epoc_id
                                ? row.epoc_id.srv_id?.service_title
                                : "-"}
                            </Typography>
                          </CardContent>
                          {selectedRequestbyID !== "1" &&
                            selectedRequestID !== "3" && (
                              <CardContent style={{ flex: 0.5 }}>
                                <Typography variant="body2">
                                  {row.dtl_eve_id
                                    ? row.dtl_eve_id?.agg_sp_dt_eve_poc_id
                                    : "-"}
                                </Typography>
                              </CardContent>
                            )}
                          {/* ✅ Conditional Data Render */}
                          {selectedRequestID === "3" ? (
                            <CardContent style={{ flex: 1 }}>
                              <Typography variant="body2">
                                {Array.isArray(row.hand_over_sess)
                                  ? row.hand_over_sess.join(", ")
                                  : row.hand_over_sess || "-"}
                              </Typography>
                            </CardContent>
                          ) : (
                            selectedRequestbyID !== "1" && (
                              <CardContent style={{ flex: 1 }}>
                                <Typography variant="body2">
                                  {row.dtl_eve_id?.actual_StartDate_Time || "-"}
                                </Typography>
                              </CardContent>
                            )
                          )}
                          <CardContent style={{ flex: 1 }}>
                            <div style={{ display: "flex" }}>
                              <Button
                                variant="contained"
                                size="small"
                                style={{
                                  textTransform: "capitalize",
                                  borderRadius: "8px",
                                  marginTop: "10px",
                                  background: "rgb(52, 123, 137)",
                                  marginRight: "8px",
                                }}
                                onClick={() => {
                                  findPreFollowupRecords(row.eve_id);
                                  if (selectedRequestID === "3") {
                                    setSelectedHandoverData(row);
                                    setMode("approve");
                                    setOpenHandover(true);
                                  } else {
                                    setOpen(true);
                                  }
                                }}
                              >
                                Approve
                              </Button>

                              <Button
                                variant="outlined"
                                size="small"
                                style={{
                                  textTransform: "capitalize",
                                  borderRadius: "8px",
                                  marginTop: "10px",
                                  color: "gray",
                                  borderColor: "gray",
                                }}
                                onClick={() => {
                                  if (selectedRequestID === "3") {
                                    findPreFollowupRecords(row.eve_id);
                                    setSelectedHandoverData(row);
                                    setMode("reject");
                                    setOpenHandover(true);
                                  } else {
                                    handleOpenReject(
                                      findPreFollowupRecords(row.eve_id),
                                    );
                                  }
                                }}
                              >
                                Reject
                              </Button>
                            </div>

                            <Modal
                              open={open}
                              onClose={handleClose}
                              aria-labelledby="modal-modal-title"
                              aria-describedby="modal-modal-description"
                            >
                              <Box
                                sx={{
                                  ...style,
                                  width: 300,
                                  borderRadius: "10px",
                                }}
                              >
                                <AppBar
                                  position="static"
                                  style={{
                                    background:
                                      " linear-gradient(90deg, rgb(240, 244, 204)",
                                    width: "22.8rem",
                                    height: "3rem",
                                    marginTop: "-16px",
                                    marginLeft: "-32px",
                                    borderRadius: "8px 10px 0 0",
                                    display: "flex",
                                  }}
                                >
                                  <div style={{ display: "flex" }}>
                                    <Typography
                                      align="center"
                                      style={{
                                        fontSize: "16px",
                                        fontWeight: 600,
                                        color: "#000000",
                                        marginTop: "10px",
                                        marginLeft: "15px",
                                      }}
                                    >
                                      PROFESSIONAL REQUEST
                                    </Typography>
                                    <Button
                                      onClick={handleClose}
                                      sx={{
                                        marginLeft: "80px",
                                        color: " #000000",
                                        marginTop: "2px",
                                      }}
                                    >
                                      <CloseIcon />
                                    </Button>
                                  </div>
                                </AppBar>
                                <Request
                                  eveId={eveId}
                                  sessionId={sessionId}
                                  requestID={selectedRequestID}
                                  selectedRequestbyID={selectedRequestbyID}
                                  srvId={srvId}
                                  reqID={rejectReqID}
                                  startDate={extractedDate}
                                  endDate={endDate}
                                  startTime={startTime}
                                  endTime={endTime}
                                  onClose={handleClose}
                                  prof={getProfRequest}
                                />
                              </Box>
                            </Modal>

                            <Modal
                              open={openReject}
                              onClose={handleCloseReject}
                              aria-labelledby="modal-modal-title"
                              aria-describedby="modal-modal-description"
                            >
                              <Box
                                sx={{
                                  ...style,
                                  width: 320,
                                  borderRadius: "10px",
                                  overflow: "hidden",
                                  bgcolor: "background.paper",
                                  boxShadow: 24,
                                  p: 0, // Removed outer padding to make AppBar align fully
                                }}
                              >
                                {/* Header with AppBar */}
                                <AppBar
                                  position="static"
                                  sx={{
                                    background: "  rgb(240, 244, 204)",
                                    height: "3rem",
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    px: 2,
                                    borderTopLeftRadius: "10px",
                                    borderTopRightRadius: "10px",
                                  }}
                                  elevation={0}
                                >
                                  <Typography
                                    variant="subtitle1"
                                    sx={{
                                      fontWeight: 600,
                                      color: "#000000",
                                      fontSize: "16px",
                                    }}
                                  >
                                    REJECT REQUEST
                                  </Typography>
                                  <IconButton
                                    onClick={handleCloseReject}
                                    sx={{
                                      color: "#000000",
                                      padding: "4px",
                                    }}
                                  >
                                    <CloseIcon />
                                  </IconButton>
                                </AppBar>

                                {/* Modal Content */}
                                <Box sx={{ px: 2, pt: 2, pb: 3 }}>
                                  <TextField
                                    required
                                    id="remark"
                                    name="remark"
                                    label="Remark"
                                    placeholder="Write remark here"
                                    size="small"
                                    value={rejectRemark}
                                    onChange={(e) =>
                                      setRejectRemark(e.target.value)
                                    }
                                    fullWidth
                                    multiline
                                    rows={2}
                                    sx={{
                                      "& .MuiInputBase-root": {
                                        fontSize: "14px",
                                      },
                                    }}
                                  />

                                  <Button
                                    variant="contained"
                                    onClick={handleRejectSubmit}
                                    sx={{
                                      textTransform: "capitalize",
                                      mt: 3,
                                      mx: "auto",
                                      display: "block",
                                      width: "70%",
                                      borderRadius: "12px",
                                      color: "#FFFFFF",
                                      backgroundColor: "rgb(100, 154, 141)",
                                    }}
                                  >
                                    Submit
                                  </Button>
                                </Box>
                              </Box>
                            </Modal>

                            {/* handoversession modal */}
                            <Modal
                              open={openHandover}
                              onClose={() => setOpenHandover(false)}
                            >
                              <Box
                                sx={{
                                  ...style,
                                  width: 400,
                                  borderRadius: "10px",
                                  maxHeight: "85vh",
                                  // overflow: "hidden",
                                  bgcolor: "background.paper",
                                  boxShadow: 24,
                                  overflowY: "auto",
                                  flexDirection: "column",
                                  p: 0, // Removed outer padding to make AppBar align fully
                                }}
                              >
                                <AppBar
                                  position="static"
                                  sx={{
                                    background: "  rgb(240, 244, 204)",
                                    height: "3rem",
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    px: 2,
                                    borderTopLeftRadius: "10px",
                                    borderTopRightRadius: "10px",
                                  }}
                                  elevation={0}
                                >
                                  <Typography
                                    align="center"
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color: "#000000",
                                    }}
                                  >
                                    {mode === "approve"
                                      ? "HANDOVER APPROVAL"
                                      : "HANDOVER REJECTION"}
                                  </Typography>
                                  <Button
                                    onClick={() => setOpenHandover(false)}
                                    sx={{
                                      color: "#000000",
                                      minWidth: "30px",
                                    }}
                                  >
                                    <CloseIcon />
                                  </Button>
                                </AppBar>

                                {selectedHandoverData && (
                                  <Handoversession
                                    data={selectedHandoverData} // ✅ pass full record
                                    eveId={eveId}
                                    sessionId={sessionId}
                                    requestID={selectedRequestID}
                                    getProfRequest={getProfRequest}
                                    mode={mode} // "approve" or "reject"
                                    onClose={() => setOpenHandover(false)}
                                  />
                                )}
                              </Box>
                            </Modal>
                          </CardContent>
                        </EnquiryCard>
                      </TableRow>
                    ))
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
        >
          <Alert
            variant="filled"
            onClose={handleSnackbarClose}
            // severity="success"
            severity={snackbarSeverity}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>

        <TablePagination
          sx={{ overflowY: "hidden" }}
          rowsPerPageOptions={[5, 10, 25, 100]}
          component="div"
          count={profRequest.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
      <Footer />
    </>
  );
};

export default ProfRequest;
